// Module
var code = "<div ui-view></div> <div ui-view=\"priestory\"></div> ";
// Exports
module.exports = code;